import { Link } from 'react-router-dom';
import { SkipLink, LiveRegion } from '../components/ui/Accessibility';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Skip Links */}
      <SkipLink href="#main-content">Skip to main content</SkipLink>
      <SkipLink href="#features">Skip to features</SkipLink>

      {/* Announce page to screen readers */}
      <LiveRegion>Gallery Platform - Home</LiveRegion>

      {/* Hero Section */}
      <header
        role="banner"
        className="flex-1 flex flex-col items-center justify-center px-6 text-center"
      >
        <main id="main-content" tabIndex={-1} className="outline-none">
          <h1 className="font-display text-5xl md:text-7xl font-bold mb-6">
            Curated Digital Gallery
          </h1>
          <p className="text-gallery-300 text-xl md:text-2xl max-w-2xl mb-12">
            Museum-grade digital art playback for events, installations, and collectors.
          </p>
          <nav aria-label="Primary actions" className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/galleries"
              className="px-8 py-4 bg-accent-600 hover:bg-accent-700 text-white font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-accent-400 focus:ring-offset-2 focus:ring-offset-gallery-950"
            >
              Browse Galleries
            </Link>
            <Link
              to="/register"
              className="px-8 py-4 border-2 border-gallery-600 hover:border-gallery-400 text-gallery-100 font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-accent-400 focus:ring-offset-2 focus:ring-offset-gallery-950"
            >
              Become an Artist
            </Link>
          </nav>
        </main>
      </header>

      {/* Features */}
      <section
        id="features"
        aria-labelledby="features-heading"
        className="py-24 px-6 bg-gallery-900"
      >
        <div className="max-w-6xl mx-auto">
          <h2
            id="features-heading"
            className="font-display text-3xl md:text-4xl font-bold text-center mb-16"
          >
            Why Gallery?
          </h2>
          <ul
            className="grid md:grid-cols-3 gap-8"
            role="list"
            aria-label="Platform features"
          >
            <li className="p-6 bg-gallery-800 rounded-xl">
              <h3 className="text-xl font-semibold mb-3 text-gallery-100">
                Artist-First Economics
              </h3>
              <p className="text-gallery-300">
                Direct payouts via Stripe Connect. You set your prices, we handle the rest.
              </p>
            </li>
            <li className="p-6 bg-gallery-800 rounded-xl">
              <h3 className="text-xl font-semibold mb-3 text-gallery-100">
                Event Playback
              </h3>
              <p className="text-gallery-300">
                Multi-screen sync, phone remote, curated playlists for weddings, conferences, and installations.
              </p>
            </li>
            <li className="p-6 bg-gallery-800 rounded-xl">
              <h3 className="text-xl font-semibold mb-3 text-gallery-100">
                Credible Protection
              </h3>
              <p className="text-gallery-300">
                Signed delivery, watermarking, and audit trails. Not impossible to copy, but traceable and low-value.
              </p>
            </li>
          </ul>
        </div>
      </section>

      {/* Footer */}
      <footer
        role="contentinfo"
        className="py-8 px-6 text-center text-gallery-400 text-sm"
      >
        <p>&copy; {new Date().getFullYear()} Gallery Platform. All rights reserved.</p>
      </footer>
    </div>
  );
}
